module.exports = __webpack_public_path__ + "img/bhutan-1.ff6bdb30.png";